<template>
  <v-row class="mx-12 my-12">
    <v-col cols="3">
      <v-card id="filters-card" class="elevation-13">
        <v-card-title class="headline">
            {{ $t('tours.filters') }}
        </v-card-title>
        <v-card-subtitle class="mt-3 pb-0">
            {{ $t('tours.region') }}
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col>
              <v-checkbox v-model="regionFilters" :label="$t('tours.busan')" color="orange" value="busan" hide-details class="ma-0"></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox v-model="regionFilters" :label="$t('tours.geojae')" color="orange" value="geojae" hide-details class="ma-0"></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox v-model="regionFilters" :label="$t('tours.ulsan')" color="orange" value="ulsan" hide-details class="ma-0"></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox v-model="regionFilters" :label="$t('tours.gyungju')" color="orange" value="gyungju" hide-details class="ma-0"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-subtitle class="mt-3 pb-0">
          {{ $t('tours.course') }}
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col>
              <v-checkbox v-model="courseFilters" label="A" color="orange" value="A" hide-details class="ma-0"></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox v-model="courseFilters" label="B" color="orange" value="B" hide-details class="ma-0"></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox v-model="courseFilters" label="C" color="orange" value="C" hide-details class="ma-0"></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox v-model="courseFilters" label="D" color="orange" value="D" hide-details class="ma-0"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-subtitle class="mt-3 pb-0">
          {{ $t('tours.timeOfDay') }}
        </v-card-subtitle>
        <v-card-text>
          <v-row>
            <v-col>
              <v-checkbox v-model="timeFilters" :label="$t('tours.day')" color="orange" value="day" hide-details class="ma-0"></v-checkbox>
            </v-col>
            <v-col>
              <v-checkbox v-model="timeFilters" :label="$t('tours.night')" color="orange" value="night" hide-details class="ma-0"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="9">
      <ToursCard :regionFilters="regionFilters" :courseFilters="courseFilters" :timeFilters="timeFilters"></ToursCard>
    </v-col>
  </v-row>
</template>
<script>
import ToursCard from '../ui/ToursCard.vue'
export default {
  name: 'ToursMain',
  computed: {
  },
  data: () => ({
    regionFilters: ['geojae', 'ulsan', 'busan', 'gyungju'],
    courseFilters: ['A', 'B', 'C', 'D'],
    timeFilters: ['day', 'night']
  }),
  components: {
    ToursCard
  }
};
</script>

<style scoped>
</style>
